import { ProFormSwitch } from '@ant-design/pro-form';
import React, { FC } from 'react';
import { SwitchFormType } from '@/presentation/components/form/index';

export const SwitchForm: FC<{ entry: SwitchFormType, hidden?: boolean }> = (props) => {
  const { name, label, transform, convertValue } = props.entry;

  return <ProFormSwitch
    transform={transform}
    convertValue={convertValue}
    unCheckedChildren={'否'}
    checkedChildren={'是'}
    name={name}
    label={label}
    hidden={props.hidden}
  />;
};
